import {
  CreateProgramaticPointRequestInterface,
  UpdateProgramaticPointRequestInterface,
  DeleteProgramaticPointRequestInterface,
} from '@/data/payload/contracts/ProgramaticPointRequest'
import dayjs from 'dayjs'

export class CreateProgramaticPointRequest
  implements CreateProgramaticPointRequestInterface {
  public programmaticPointName?: string
  public programmaticPointTarget?: string
  public selectedUser?: string
  public programmaticPointTrigger?: string
  public routes?: number[]
  public scheduledAt?: string
  public invoiceSource?: string
  public paymentMethodUsed?: string
  public minimumTransaction?: number
  public programmaticPointPurpose?: string
  public isPercentage?: boolean
  public amount?: number
  public percentOfTransaction?: number
  public maxAmountGiven?: number | null
  public isExactDate?: boolean
  public expiredDate?: string | null
  public expiryDay?: number
  public limitPerDay?: number
  public limitPerUser?: number
  public budgetSource?: string
  public startDate?: string
  public endDate?: string
  public actorName?: string
  public membershipLevel?: string
  public budgetAmount?: null | undefined | number

  constructor(
    programmaticPointName?: string,
    programmaticPointTarget?: string,
    selectedUser?: string,
    programmaticPointTrigger?: string,
    routes?: number[],
    scheduledAt?: string,
    invoiceSource?: string,
    paymentMethodUsed?: string,
    minimumTransaction?: number,
    programmaticPointPurpose?: string,
    isPercentage?: boolean,
    amount?: number,
    percentOfTransaction?: number,
    maxAmountGiven?: number | null,
    isExactDate?: boolean,
    expiredDate?: string | null,
    expiryDay?: number,
    limitPerDay?: number,
    limitPerUser?: number,
    budgetSource?: string,
    startDate?: string,
    endDate?: string,
    actorName?: string,
    membershipLevel?: string,
    budgetAmount?: null | number
  ) {
    this.programmaticPointName = programmaticPointName
    this.programmaticPointTarget = programmaticPointTarget
    this.selectedUser = selectedUser
    this.programmaticPointTrigger = programmaticPointTrigger
    this.routes = routes
    this.scheduledAt = scheduledAt
    this.invoiceSource = invoiceSource
    this.paymentMethodUsed = paymentMethodUsed
    this.minimumTransaction = minimumTransaction
    this.programmaticPointPurpose = programmaticPointPurpose
    this.isPercentage = isPercentage
    this.amount = amount
    this.percentOfTransaction = percentOfTransaction
    this.maxAmountGiven = maxAmountGiven
    this.isExactDate = isExactDate
    this.expiredDate = expiredDate
      ? dayjs(expiredDate).format('DD-MM-YYYY')
      : null
    this.expiryDay = expiryDay
    this.limitPerDay = limitPerDay
    this.limitPerUser = limitPerUser
    this.budgetSource = budgetSource
    this.startDate = startDate
    this.endDate = endDate
    this.actorName = actorName
    this.membershipLevel = membershipLevel
    this.budgetAmount = budgetAmount
  }

  public toPayload(): string {
    const data = {
      programmatic_point_name: this.programmaticPointName,
      programmatic_point_target: this.programmaticPointTarget,
      selected_user: this.selectedUser,
      programmatic_point_trigger: this.programmaticPointTrigger,
      route_id: this.routes,
      scheduled_at: this.scheduledAt,
      invoice_source: this.invoiceSource,
      payment_method_used: this.paymentMethodUsed,
      minimum_transaction: this.minimumTransaction,
      programmatic_point_purpose: this.programmaticPointPurpose,
      is_percentage: this.isPercentage,
      amount: this.amount,
      percent_of_transaction: this.percentOfTransaction,
      max_amount_given: this.maxAmountGiven,
      is_exact_date: this.isExactDate,
      expiry_day: this.expiryDay,
      expired_date: this.expiredDate,
      limit_per_day: this.limitPerDay,
      limit_per_user: this.limitPerUser,
      budget_source: this.budgetSource,
      start_date: this.startDate,
      end_date: this.endDate,
      actor_name: this.actorName,
      membership_level: this.membershipLevel,
    }

    if (typeof this.budgetAmount === 'number' && this.budgetAmount > 0) {
      return JSON.stringify({ budget_amount: this.budgetAmount, ...data })
    }

    return JSON.stringify(data)
  }
}

export class UpdateProgramaticPointRequest
  implements UpdateProgramaticPointRequestInterface {
  public programmaticPointName?: string
  public programmaticPointTarget?: string
  public selectedUser?: string
  public programmaticPointTrigger?: string
  public routes?: number[]
  public scheduledAt?: string
  public programmaticPointPurpose?: string
  public amount?: number
  public expiryDay?: number
  public limitPerDay?: number
  public startDate?: string
  public endDate?: string
  public actorName?: string
  public budgetAmount?: null | number | undefined

  constructor(
    programmaticPointName?: string,
    programmaticPointTarget?: string,
    selectedUser?: string,
    programmaticPointTrigger?: string,
    routes?: number[],
    scheduledAt?: string,
    programmaticPointPurpose?: string,
    amount?: number,
    expiryDay?: number,
    limitPerDay?: number,
    startDate?: string,
    endDate?: string,
    actorName?: string,
    budgetAmount?: null | number | undefined
  ) {
    this.programmaticPointName = programmaticPointName
    this.programmaticPointTarget = programmaticPointTarget
    this.selectedUser = selectedUser
    this.programmaticPointTrigger = programmaticPointTrigger
    this.routes = routes
    this.scheduledAt = scheduledAt
    this.programmaticPointPurpose = programmaticPointPurpose
    this.amount = amount
    this.expiryDay = expiryDay
    this.limitPerDay = limitPerDay
    this.startDate = startDate
    this.endDate = endDate
    this.actorName = actorName
    this.budgetAmount = budgetAmount
  }

  public toPayload() {
    const data = {
      programmatic_point_name: this.programmaticPointName,
      programmatic_point_target: this.programmaticPointTarget,
      selected_user: this.selectedUser,
      programmatic_point_trigger: this.programmaticPointTrigger,
      route_id: this.routes,
      scheduled_at: this.scheduledAt,
      programmatic_point_purpose: this.programmaticPointPurpose,
      amount: this.amount,
      expiry_day: this.expiryDay,
      limit_per_day: this.limitPerDay,
      start_date: this.startDate,
      end_date: this.endDate,
      actor_name: this.actorName,
    }

    if (typeof this.budgetAmount === 'number' && this.budgetAmount > 0) {
      return JSON.stringify({ budget_amount: this.budgetAmount, ...data })
    }

    return JSON.stringify(data)
  }
}

export class DeleteProgramaticPointRequest
  implements DeleteProgramaticPointRequestInterface {
  public actorName?: string

  constructor(actorName?: string) {
    this.actorName = actorName
  }

  public toPayload() {
    const data = {
      actor_name: this.actorName,
    }

    return JSON.stringify({
      ...data,
    })
  }
}
